export enum ReadinessStatus {
    Completed = 1,
    Pending = 2,
    Overdue = 3
}

export const ReadinessStatusNames = new Map<number, string>([
    [ReadinessStatus.Completed, 'Complete'],
    [ReadinessStatus.Pending, 'Pending'],
    [ReadinessStatus.Overdue, 'Overdue'],
]);